import $ from "jquery";

$.migrateMute = true;

// jquery-migrate v4 unconditionally logs a "Migrate is installed" banner on
// load — migrateMute only drops the "with logging active" phrase and
// suppresses later per-warning logging, not this one line. There's no public
// flag to skip it, so swallow console.log for the synchronous duration of the
// require() below (jquery-migrate logs nothing else at module load time).
/* eslint-disable no-console */
const originalLog = console.log;

console.log = () => {};
require("jquery-migrate");

console.log = originalLog;
/* eslint-enable no-console */
